import { AppResponse } from '@/types';
import Http from '@/utils/http';

// 设置练习设置
export const savePracticeSetting = (params: {
    projectId: number;
    subjectId: number;
    practiceMode?: number;
    practiceNum?: number;
    settingJson?: string;
    yearType?: number;
}): Promise<AppResponse<any>> => Http.post('/minerva/api/v1/front/setting', params);

// 获取练习设置题数
export const getPracticeSetting = (params: {
    projectId: number;
    subjectId: number;
}): Promise<
    AppResponse<{
        practiceMode: number; // 刷题模式
        practiceNum: number; // 刷题数量
        projectId: number;
        subjectId: number;
        settingJson: string;
        yearType: number; // 年份类型
    }>
> => Http.get('/minerva/api/v1/front/setting', params);
